import { render, staticRenderFns } from "./field-phone-number.vue?vue&type=template&id=65544a7e&scoped=true&"
import script from "./field-phone-number.vue?vue&type=script&lang=js&"
export * from "./field-phone-number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65544a7e",
  null
  
)

export default component.exports